import {
  Cable,
  TextCursorInputIcon,
  BotIcon,
  ImageIcon,
  SearchIcon,
  AudioLinesIcon,
  BotMessageSquareIcon,
  GlobeIcon,
  SplitIcon,
  Volume2Icon,
  VideoIcon,
  TvMinimalPlay,
  LogIn,
  LogOut,
  WrenchIcon,
  BrainIcon,
  ChevronsLeftRightEllipsis,
  TextIcon,
  CogIcon,
  FileChartColumn,
  FileUp,
  Braces,
  GalleryVerticalEnd,
  Edit,
  StickyNote,
  Database,
  DatabaseZap,
  Layers,
  Layers2,
  LayoutDashboard,
  BookOpen,
  FileBarChart,
  GalleryThumbnails,
  Code,
  FileCode2,
  ListChecks,
  ListPlus,
  ListTree,
  Sigma,
  WorkflowIcon,
  ChartLine,
  ChartNoAxesCombined,
  ChartColumn,
  SlidersHorizontal,
  ShieldCheck,
  OctagonPause,
  Shapes,
  FileSpreadsheet,
  FileText,
  Presentation,
  FolderClosed,
  FolderKanban,
  Network,
  TerminalSquare,
  Clapperboard,
  GitBranch,
  GitFork,
  BadgeCheck,
  Repeat,
  Bell,
  Rocket,
  Tag,
  Camera,
  CloudDownload,
  MonitorCheck,
  DraftingCompass,
  PackageCheck,
  FilePen,
  Projector,
  Snowflake,
  Ticket,
  Landmark,
  Radio,
  Frame,
  Search,
  // --- logic nodes (Phase 5/6 icon coverage; Phase 8 nodes pick from these) ---
  Split,
  Calculator,
  IterationCw,
  Repeat1,
  Tags,
  // --- end logic nodes ---
} from 'lucide-react';

export type IconName =
  | 'Cable'
  | 'TextCursorInputIcon'
  | 'BotIcon'
  | 'ImageIcon'
  | 'SearchIcon'
  | 'AudioLinesIcon'
  | 'BotMessageSquareIcon'
  | 'GlobeIcon'
  | 'SplitIcon'
  | 'Volume2Icon'
  | 'VideoIcon'
  | 'TvMinimalPlay'
  | 'LogIn'
  | 'LogOut'
  | 'WrenchIcon'
  | 'BrainIcon'
  | 'ChevronsLeftRightEllipsis'
  | 'TextIcon'
  | 'CogIcon'
  | 'FileChartColumn'
  | 'FileUp'
  | 'Braces'
  | 'GalleryVerticalEnd'
  | 'Edit'
  | 'StickyNote'
  | 'Database'
  | 'DatabaseZap'
  | 'Layers'
  | 'Layers2'
  | 'LayoutDashboard'
  | 'BookOpen'
  | 'FileBarChart'
  | 'GalleryThumbnails'
  | 'Code'
  | 'FileCode2'
  | 'FileCode2Icon'
  | 'ListChecks'
  | 'ListPlus'
  | 'ListTree'
  | 'Sigma'
  | 'WorkflowIcon'
  | 'ChartLine'
  | 'ChartNoAxesCombined'
  | 'SlidersHorizontal'
  | 'ChartColumn'
  | 'ShieldCheck'
  | 'OctagonPause'
  | 'Shapes'
  | 'FileSpreadsheet'
  | 'FileText'
  | 'Presentation'
  | 'FolderClosed'
  | 'FolderKanban'
  | 'Network'
  | 'NetworkIcon'
  | 'TerminalSquareIcon'
  | 'Clapperboard'
  | 'GitBranch'
  | 'GitFork'
  | 'BadgeCheck'
  | 'Repeat'
  | 'Bell'
  | 'BellIcon'
  | 'Rocket'
  | 'RocketIcon'
  | 'Tag'
  | 'TagIcon'
  | 'Camera'
  | 'CloudDownload'
  | 'MonitorCheck'
  | 'MonitorCheckIcon'
  | 'DraftingCompass'
  | 'PackageCheck'
  | 'FilePen'
  | 'Projector'
  | 'Snowflake'
  | 'Ticket'
  | 'Landmark'
  | 'Radio'
  | 'RadioIcon'
  | 'BracesIcon'
  | 'Frame'
  | 'Search'
  // --- logic nodes (Phase 5/6 icon coverage; Phase 8 nodes pick from these) ---
  | 'Split'
  | 'Calculator'
  | 'IterationCw'
  | 'Repeat1'
  | 'Tags';
// --- end logic nodes ---

/** The glyph drawn for an icon name the map does not know. */
export const FALLBACK_ICON_NAME: IconName = 'Shapes';

export type IconProps = {
  className?: string;
  style?: React.CSSProperties;
  'aria-label'?: string;
  /** Set by `getIconComponent` when the requested name was unknown. */
  'data-icon-fallback'?: string;
};

export const iconMap: Record<IconName, React.ComponentType<IconProps>> = {
  Cable,
  TextCursorInputIcon,
  BotIcon,
  ImageIcon,
  SearchIcon,
  AudioLinesIcon,
  BotMessageSquareIcon,
  GlobeIcon,
  SplitIcon,
  Volume2Icon,
  VideoIcon,
  TvMinimalPlay,
  LogIn,
  LogOut,
  WrenchIcon,
  BrainIcon,
  ChevronsLeftRightEllipsis,
  TextIcon,
  CogIcon,
  FileChartColumn,
  FileUp,
  Braces,
  GalleryVerticalEnd,
  Edit,
  StickyNote,
  Database,
  DatabaseZap,
  Layers,
  Layers2,
  LayoutDashboard,
  BookOpen,
  FileBarChart,
  GalleryThumbnails,
  Code,
  FileCode2,
  FileCode2Icon: FileCode2,
  ListChecks,
  ListPlus,
  ListTree,
  Sigma,
  WorkflowIcon,
  ChartLine,
  ChartNoAxesCombined,
  SlidersHorizontal,
  ChartColumn,
  ShieldCheck,
  OctagonPause,
  Shapes,
  FileSpreadsheet,
  FileText,
  Presentation,
  FolderClosed,
  FolderKanban,
  Network,
  NetworkIcon: Network,
  TerminalSquareIcon: TerminalSquare,
  Clapperboard,
  GitBranch,
  GitFork,
  BadgeCheck,
  Repeat,
  Bell,
  BellIcon: Bell,
  Rocket,
  RocketIcon: Rocket,
  Tag,
  TagIcon: Tag,
  Camera,
  CloudDownload,
  MonitorCheck,
  MonitorCheckIcon: MonitorCheck,
  DraftingCompass,
  PackageCheck,
  FilePen,
  Projector,
  Snowflake,
  Ticket,
  Landmark,
  Radio,
  RadioIcon: Radio,
  BracesIcon: Braces,
  Frame,
  Search,
  // --- logic nodes (Phase 5/6 icon coverage; Phase 8 nodes pick from these) ---
  Split,
  Calculator,
  IterationCw,
  Repeat1,
  Tags,
  // --- end logic nodes ---
};

type IconComponent = (typeof iconMap)[IconName];

/**
 * The component for an icon name, or null when the map does not know it.
 * Use this (or `hasIcon`) when "unknown" must be visible to the caller;
 * `getIconComponent` never returns null any more.
 */
export const resolveIconComponent = (
  iconName: IconName | string | null | undefined,
): IconComponent | null =>
  iconName && Object.prototype.hasOwnProperty.call(iconMap, iconName)
    ? iconMap[iconName as IconName]
    : null;

/** True when the catalog's icon name resolves to a glyph in the map. */
export const hasIcon = (
  iconName: IconName | string | null | undefined,
): boolean => resolveIconComponent(iconName) !== null;

export const getIconComponent = (
  iconName: IconName | string,
  color?: string,
  className: string = 'w-4 h-4',
): React.ReactNode => {
  // An unknown name (a backend ahead of this build, a typo in a node class)
  // used to render nothing, so the node showed a blank square. Draw a
  // generic shape instead and say which name was missing, so the gap is
  // visible without being a hole.
  const known = resolveIconComponent(iconName);
  const Component = known ?? iconMap[FALLBACK_ICON_NAME];
  // If color is provided, use inline style. Otherwise, use theme-aware Tailwind classes
  const defaultColorClass = 'text-black dark:text-white';
  // Only add default color classes if className doesn't already contain text-* color classes
  const hasTextColorClass = /text-\w+/.test(className);
  const combinedClassName = color
    ? className
    : hasTextColorClass
      ? className
      : `${className} ${defaultColorClass}`;

  return (
    <Component
      className={combinedClassName}
      style={color ? { color: color } : undefined}
      {...(known
        ? {}
        : {
            'data-icon-fallback': iconName || 'none',
            'aria-label': `Icon "${iconName || 'none'}" is not available`,
          })}
    />
  );
};
